import React from 'react';

import {
  OptionItemSquareListStyles,
  OptionItemSquareStyles,
  OptionItemSquareTitleStyles,
} from './OptionItemSquare.styles';

export const OptionItemSquareList: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OptionItemSquareListStyles className={className}>
      {children}
    </OptionItemSquareListStyles>
  );
};

export const OptionItemSquare: React.FC<{
  bgSrc: string;
  title: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
}> = ({ bgSrc, title, isSelected, onClick, TEST_ID }) => {
  return (
    <OptionItemSquareStyles
      isSelected={isSelected}
      bgSrc={bgSrc}
      onClick={onClick}
      data-testid={TEST_ID}
      className="option-item-square"
      role="button"
    >
      <img src={bgSrc} alt={title} />
      <div className="shadow-mask" />
      <OptionItemSquareTitleStyles variant="label-large">
        {title}
      </OptionItemSquareTitleStyles>
    </OptionItemSquareStyles>
  );
};
